import { useState, useEffect } from 'react';

// Set once the user has already confirmed leaving (e.g. the save-conflict
// dialog), so the browser doesn't ask a second time.
let navigationAllowed = false;

export const allowNavigationWithUnsavedChanges = () => {
  navigationAllowed = true;
};

const useUnsavedAlert = () => {
  const [unsavedStatus, setUnsavedStatus] = useState(false);

  const warnOnNavigate = (e) => {
    if (!unsavedStatus || navigationAllowed) {
      return true;
    }
    e.preventDefault();
    e.returnValue = 'unsaved changes';
    return e.returnValue;
  };

  useEffect(() => {
    // IE beforeunload acts weird so just don't use it
    const isIE =
      window.navigator.userAgent.indexOf('MSIE') > 0 ||
      !!navigator.userAgent.match(/Trident.*rv:11\./);
    if (!isIE) {
      window.addEventListener('beforeunload', warnOnNavigate);
    }
    return () => {
      window.removeEventListener('beforeunload', warnOnNavigate);
    };
  }, [unsavedStatus]);

  return [unsavedStatus, setUnsavedStatus];
};

export default useUnsavedAlert;
